import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
// import Route from "./utils/Route";
import LayoutDefault from "./layouts/LayoutDefault";
import Home from "./views/v2/Home";
import About from "./views/About";
import ComingSoon from "./views/ComingSoon";
import PrivacyPolicy from "./views/PrivacyPolicy";
import Terms from "./views/Terms";
import Rules from "./views/Rules";
import DataDeletion from "./views/DataDeletion";
import Support from "./views/Support";
import Play from "./views/Play";
import Broadcast from "./views/Broadcast";
import Demo from "./views/Demo";
import Calculator from "./views/Calculator";
import TV from "./views/TV";
import AdvancedStats from "./views/v2/AdvancedStats";
import "./index.css";
import DrivesScore from "./views/v2/DrivesScore";
import Football from "./views/v2/Football";
import Baseball from "./views/v2/Baseball";
import Golf from "./views/v2/Golf";
import WhyDrives from "./views/v2/WhyDrives";
import ScrollToTop from "./views/ScrollToTop";
import BaseballBroadcast from "./views/BaseballBroadcast";
import BaseballPlay from "./views/BaseballPlay";
import DrivesFi from "./views/v2/DrivesFi";

const createRoute = (path, showDefaultLayout, children) => {
  return (
    <React.Fragment>
      <Route
        exact
        path={path}
        element={
          showDefaultLayout ? (
            <LayoutDefault>{children}</LayoutDefault>
          ) : (
            children
          )
        }
      />
      <Route
        exact
        path={`/football${path}`}
        element={
          showDefaultLayout ? (
            <LayoutDefault>{children}</LayoutDefault>
          ) : (
            children
          )
        }
      />
    </React.Fragment>
  );
};

const App = () => {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        {createRoute("", true, <Home />)}
        {createRoute("/why-drives", true, <WhyDrives />)}
        {createRoute("/about", true, <About />)}
        {createRoute("/drives-score", true, <DrivesScore />)}
        {createRoute("/stats", true, <AdvancedStats />)}
        {createRoute("/coming-soon", true, <ComingSoon />)}
        {createRoute("/privacy-policy", true, <PrivacyPolicy />)}
        {createRoute("/terms-of-service", true, <Terms />)}
        {createRoute("/support", true, <Support />)}
        {createRoute("/play", true, <Play />)}
        {createRoute("/data-deletion", true, <DataDeletion />)}
        {createRoute("/tv", false, <TV />)}
        {createRoute("/broadcast", false, <Broadcast />)}
        {createRoute("/calc", true, <Calculator />)}
        {createRoute("/rules", true, <Rules />)}
        {createRoute("/demo", true, <Demo />)}
        {createRoute("/drives-score", true, <DrivesScore />)}
        {createRoute("/american-football", true, <Football />)}
        {createRoute("/baseball", true, <Baseball />)}
        {createRoute("/golf", true, <Golf />)}
        {createRoute("/baseball-broadcast", false, <BaseballBroadcast />)}
        {createRoute("/baseball-play", true, <BaseballPlay />)}
        {createRoute("/drivesfi", true, <DrivesFi />)}
      </Routes>
    </BrowserRouter>
  );
};

export default App;
